import type { SelfProjectDto } from "@/api/types";

import { useSessionUser } from "./useSessionUser";

export function useProject(): SelfProjectDto {
  const sessionUser = useSessionUser();
  const currProject = sessionUser.project;

  return currProject;
}
